import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import HeaderBar from '../../components/HeaderBar/HeaderBar'
import './Service29.css'
import Service29PendingTab from './Service29PendingTab'
import Service29ActiveTab from './Service29ActiveTab'
import Service29HistoryTab from './Service29HistoryTab'

import { selectIsAdmin } from '../../redux/slices'

type Tab = 'Pending' | 'Active' | 'History'

const Service29 = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const isAdmin = useSelector(selectIsAdmin)

  const tabs: Tab[] = isAdmin
    ? ['Pending', 'Active', 'History']
    : ['Pending', 'Active']

  const tabParam = searchParams.get('tab') as Tab | null
  const activeTab: Tab =
    tabParam && tabs.includes(tabParam) ? tabParam : 'Pending'

  const setActiveTab = (tab: Tab) => setSearchParams({ tab })

  return (
    <article style={{ margin: '0 auto', padding: '0 1rem' }}>
      <header>
        <HeaderBar
          origin="Devices"
          routes={[{ title: 'Service 29 Certifications' }]}
          help={{
            title: 'Service 29 Certifications',
            text: (
              <>
                <p>
                  Service 29 Certificate Management allows you to manage vehicle
                  certificates across their full lifecycle.
                </p>
                <p>
                  Use the <strong>Pending</strong> tab to review and approve
                  certificate requests. The <strong>Active</strong> tab shows
                  currently issued and installed certificates, where you can
                  initiate revocations. Administrators can view revoked and
                  expired certificates in the <strong>History</strong> tab.
                </p>
              </>
            )
          }}
        />
      </header>
      <main className="card">
        <fieldset className="btn-group cert-view-switcher">
          <legend className="sr-only">View</legend>
          {tabs.map((tab) => (
            <Fragment key={tab}>
              <input
                type="radio"
                id={`cert-view-${tab}`}
                name="cert-view"
                value={tab}
                checked={activeTab === tab}
                onChange={() => setActiveTab(tab)}
              />
              <label
                className="btn btn-outline-secondary"
                htmlFor={`cert-view-${tab}`}
              >
                {tab}
              </label>
            </Fragment>
          ))}
        </fieldset>
        <div className="panel panel-info">
          {activeTab === 'Pending' && <Service29PendingTab />}
          {activeTab === 'Active' && <Service29ActiveTab />}
          {activeTab === 'History' && <Service29HistoryTab />}
        </div>
      </main>
    </article>
  )
}

export default Service29
